export interface AppBrandingConfig {
  appName: string;
  shortName: string;
  browserTitle: string;
  logoAltText: string;
  sidebarLogoSrc: string;
  sidebarCollapsedLogoSrc: string;
  loginLogoSrc: string;
  sidebarLogoTextLines: string[];
  copyrightOwner: string;
}

export const APP_BRANDING: AppBrandingConfig = {
  appName: 'Commercial Margin Intelligence',
  shortName: 'CMI',
  browserTitle: 'Commercial Margin Intelligence',
  logoAltText: 'Commercial Margin Intelligence logo',
  sidebarLogoSrc: 'assets/images/Logo.svg',
  sidebarCollapsedLogoSrc: 'assets/images/Group.svg',
  loginLogoSrc: 'assets/images/Logo.svg',
  sidebarLogoTextLines: ['commercial', 'margin intelligence'],
  copyrightOwner: 'Commercial Margin Intelligence',
};
